const getAjaxConfig = () => ({
  ajaxUrl: (window.theme && theme.ajax_url) || "/wp-admin/admin-ajax.php",
  nonce: (window.theme && theme.nonce) || "",
});

const optionsLoadPromises = new WeakMap();

const loadCardOptions = async (productsCard, optionsWrapper) => {
  if (!(optionsWrapper instanceof HTMLElement)) {
    return false;
  }

  if (optionsWrapper.dataset.optionsPending !== "1") {
    return true;
  }

  if (optionsLoadPromises.has(optionsWrapper)) {
    return optionsLoadPromises.get(optionsWrapper);
  }

  const productId =
    optionsWrapper.dataset.productId || productsCard.dataset.productId;
  if (!productId) {
    return false;
  }

  const { ajaxUrl, nonce } = getAjaxConfig();
  optionsWrapper.dataset.optionsLoading = "1";
  optionsWrapper.classList.add("is-loading-options");

  const promise = (async () => {
    try {
      const body = new URLSearchParams();
      body.set("action", "mettevo_product_card_options");
      body.set("product_id", productId);
      body.set("nonce", nonce);

      const response = await fetch(ajaxUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: body.toString(),
        credentials: "same-origin",
      });

      const json = await response.json();
      if (!json || !json.success || !json.data || !json.data.html) {
        return false;
      }

      optionsWrapper.innerHTML = json.data.html;
      optionsWrapper.dataset.optionsPending = "0";
      delete optionsWrapper.dataset.optionsPending;

      const imageWrapper = productsCard.querySelector(
        ".product-card__image-wrapper"
      );
      if (imageWrapper && json.data.variation_galleries) {
        imageWrapper.setAttribute(
          "data-variation-galleries",
          JSON.stringify(json.data.variation_galleries)
        );
      }

      if (typeof window.ProductRadioBtn === "function") {
        window.ProductRadioBtn(optionsWrapper);
      }

      const closeOptionsBtn = optionsWrapper.querySelector(".close-options-btn");
      if (closeOptionsBtn && !closeOptionsBtn.dataset.boundClose) {
        closeOptionsBtn.dataset.boundClose = "1";
        closeOptionsBtn.addEventListener("click", () => {
          productsCard.classList.remove("active");
          optionsWrapper.classList.remove("open-left", "open-right");
        });
      }

      return true;
    } catch (error) {
      return false;
    } finally {
      delete optionsWrapper.dataset.optionsLoading;
      optionsWrapper.classList.remove("is-loading-options");
      optionsLoadPromises.delete(optionsWrapper);
    }
  })();

  optionsLoadPromises.set(optionsWrapper, promise);
  return promise;
};

const ProductCardOptions = (customCards = null) => {
  let productsCards = [];

  if (customCards instanceof HTMLElement) {
    if (customCards.classList.contains("product-card__wrapper")) {
      productsCards = [customCards];
    } else {
      productsCards = [
        ...customCards.querySelectorAll(".product-card__wrapper"),
      ];
    }
  } else {
    productsCards = [...document.querySelectorAll(".product-card__wrapper")];
  }

  const windowWidth = window.innerWidth;

  if (productsCards.length === 0) {
    return;
  }

  const productsCardsContainer = productsCards[0].closest(".container");

  productsCards.forEach((productsCard) => {
    if (productsCard.dataset.optionsUiBound === "1") {
      return;
    }

    const openOptionsBtn = productsCard.querySelector(".open-options-btn");
    const optionsWrapper = productsCard.querySelector(
      ".product-card__options-wrapper"
    );

    if (!openOptionsBtn || !optionsWrapper) {
      return;
    }

    productsCard.dataset.optionsUiBound = "1";

    const closeOptions = () => {
      productsCard.classList.remove("active");
      optionsWrapper.classList.remove("open-left", "open-right");
    };

    const positionAndOpen = () => {
      productsCards.forEach((card) => {
        card.classList.remove("active");
        const options = card.querySelector(".product-card__options-wrapper");
        if (options) {
          options.classList.remove("open-left", "open-right");
        }
      });

      if (!productsCardsContainer) {
        optionsWrapper.classList.add("open-right");
        productsCard.classList.add("active");
        return;
      }

      const productsCardsContainerRect =
        productsCardsContainer.getBoundingClientRect();
      const cardRect = productsCard.getBoundingClientRect();
      let offset = 12;

      if (windowWidth >= 1024) {
        offset = 41;
      } else if (windowWidth >= 768) {
        offset = 21;
      }

      if (cardRect.right >= productsCardsContainerRect.right - offset) {
        optionsWrapper.classList.add("open-left");
        optionsWrapper.classList.remove("open-right");
      } else {
        optionsWrapper.classList.add("open-right");
        optionsWrapper.classList.remove("open-left");
      }

      productsCard.classList.add("active");
    };

    const openOptions = async () => {
      const loaded = await loadCardOptions(productsCard, optionsWrapper);
      if (!loaded && optionsWrapper.dataset.optionsPending === "1") {
        return;
      }
      positionAndOpen();
    };

    if (window.innerWidth >= 1440) {
      openOptionsBtn.addEventListener("mouseenter", openOptions);
      productsCard.addEventListener("mouseleave", closeOptions);
    } else {
      openOptionsBtn.addEventListener("click", openOptions);

      document.addEventListener("click", (e) => {
        if (!productsCard.contains(e.target)) {
          closeOptions();
        }
      });
    }
  });
};

window.ProductCardOptions = ProductCardOptions;
window.mettevoLoadProductCardOptions = loadCardOptions;

export default ProductCardOptions;
